import guid from 'core/utils/enums/guid'
import { urlMedia } from '../requesters/Requester'
import * as frFR from './translations/fr_FR.json'

async function fetchTranslations(url) {
  const response = await fetch(url)
  return response.json()
}

const getTranslations = async filename => {
  if (process.env.REACT_APP_PROD) {
    const result = await fetchTranslations(
      `${urlMedia()}/translations/openflex/${process.env.REACT_APP_PROD}/${
        guid.GLOBALDEALER
      }/${filename}`
    )
    return result
  }

  const result = await fetchTranslations(
    `${urlMedia()}/translations/${guid.GLOBALDEALER}/${filename}`
  )
  return result
}

/**
 * Load local languages
 * @param {String} locale
 */
export default async function loadTranslations(locale) {
  let filename
  switch (locale) {
    case 'fr':
      return frFR.default
    case 'de':
      filename = 'de_DE.json'
      break
    case 'it':
      filename = 'it_IT.json'
      break
    case 'es':
      filename = 'es_ES.json'
      break
    case 'nb':
      filename = 'nb_NO.json'
      break
    case 'fi':
      filename = 'fi_FI.json'
      break
    case 'sv':
      filename = 'sv_SE.json'
      break
    case 'en':
    default:
      filename = 'en_GB.json'
      break
  }

  try {
    const result = await getTranslations(filename)
    return result
  } catch (e) {
    //error getting translations, try to get en_GB
    try {
      const result = await getTranslations('en_GB.json')
      return result
    } catch (err) {
      //still in error , return fr
      return frFR.default
    }
  }
}
